import { useEffect, useState } from 'react';
import { JurisdictionCodesType } from 'src/components/Common/Jurisdiction/types';
import getCookies from 'src/lib/Utils/Cookies';
import Logger from 'src/lib/Utils/Logger';

const useJurisdictionValue = () => {
  const [jurisdictionValue, setJurisdictionValue] = useState<JurisdictionCodesType>();

  useEffect(() => {
    if (getCookies()?.DEC) {
      try {
        const jurisdiction = JSON.parse(getCookies()?.DEC)?.JU;
        setJurisdictionValue(jurisdiction);
      } catch (err) {
        Logger(err);
      }
    }
  }, []);

  return jurisdictionValue;
};

export default useJurisdictionValue;
